import { Outlet } from "react-router-dom";
import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';

const LayoutTimesheet = () => {
  const location = useLocation();
  let timesheetStylesLoaded = false;

  useEffect(() => {
    const isTimesheetRoute = location.pathname.startsWith('/timesheet');

    if (isTimesheetRoute && !timesheetStylesLoaded) {
      import('../tailwind.css')
        .then(() => {
          // console.log('Estilos do Timesheet carregados.');
          timesheetStylesLoaded = true;
        })
        .catch(error => {
          console.error('Erro ao carregar estilos do Timesheet:', error);
        });
    } else if (!isTimesheetRoute && timesheetStylesLoaded) {
      // Se você precisar remover os estilos ao sair das rotas (mais complexo)
      // Isso exigiria uma forma de rastrear e remover as folhas de estilo injetadas.
      console.log('Não estamos em rotas de timesheet.');
    }
  }, [location]);

    return (
    <>
      <Outlet />
    </>
  )
};

export default LayoutTimesheet;